/**
 * EverOut Placeholder Image Generator
 *
 * Displays the EverOut skyline illustration on a tinted dark background
 * for items without images. Each placeholder is seeded from a data attribute
 * so the same item always gets the same look, but different items vary.
 *
 * Usage: Add class="eo-placeholder" data-seed="Some Item Name" to a container.
 * This script runs on DOMContentLoaded and fills all matching elements.
 */

const SKYLINE_PATH = '/assets/images/skyline-transparent.png';
const LOGO_PATH = '/assets/images/eo-mono-white.png';

// Dark background colors with subtle tint variation.
const BACKGROUNDS = [
  '#212121',
  '#1a2a3a',
  '#2a1015',
  '#1a2a10',
  '#1f1a2e',
  '#2a2a2e',
  '#1a2520',
  '#2a2015',
];

// Scale and horizontal offset ranges for skyline variation.
const SCALES = [1.5, 1.55, 1.6, 1.65, 1.7, 1.75];
const OFFSETS = [-15, -10, -5, 0, 5, 10, 15];

function hashStr(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash = hash & hash;
  }
  return Math.abs(hash);
}

function generatePlaceholder(el) {
  const seed = el.dataset.seed || '';
  const h = hashStr(seed);
  const bg = BACKGROUNDS[h % BACKGROUNDS.length];
  const isBanner = el.classList.contains('eo-placeholder--banner');
  const isSquare = el.classList.contains('eo-placeholder--square');

  // Smaller containers look chaotic with the default zoom — tamp it
  // down for square rows and banner strips.
  const scaleMultiplier = isBanner ? 0.75 : isSquare ? 0.8 : 1;
  const scale = SCALES[(h >> 3) % SCALES.length] * scaleMultiplier;
  const offsetX = OFFSETS[(h >> 6) % OFFSETS.length];

  el.style.backgroundColor = bg;

  const skyline = document.createElement('img');
  skyline.className = 'eo-placeholder__skyline';
  skyline.src = SKYLINE_PATH;
  skyline.alt = '';
  skyline.style.transform = `translate(calc(-50% + ${offsetX}%), -50%) scale(${scale})`;

  el.appendChild(skyline);

  // Banner variant is skyline-only; no EO stamp.
  if (!isBanner) {
    const badge = document.createElement('div');
    badge.className = 'eo-placeholder__badge';

    const logo = document.createElement('img');
    logo.className = 'eo-placeholder__logo';
    logo.src = LOGO_PATH;
    logo.alt = '';

    el.appendChild(badge);
    el.appendChild(logo);
  }
}

function initPlaceholders(root) {
  const els = (root || document).querySelectorAll('.eo-placeholder:not([data-initialized])');
  els.forEach(function (el) {
    el.dataset.initialized = 'true';
    generatePlaceholder(el);
  });
}

// Run on initial page load
document.addEventListener('DOMContentLoaded', function () {
  initPlaceholders();
});

// Expose for dynamic content (sliders that load later, etc.)
window.initEoPlaceholders = initPlaceholders;
